import React from 'react';

const TIPO_CORES = {
  default: 'var(--amber)',
  sobreaviso: 'var(--purple)',
  ajuste: 'var(--green)',
};

export default function CardIndicador({ label, valor, al, ra, tipo = 'default' }) {
  const corEsquerda = TIPO_CORES[tipo] || TIPO_CORES.default;

  return (
    <div style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderLeft: `4px solid ${corEsquerda}`,
      borderRadius: 'var(--radius-md)',
      padding: '20px',
      minWidth: 0,
    }}>
      <div style={{
        fontSize: 'var(--font-sm)',
        color: 'var(--muted)',
        marginBottom: '4px',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
      }}>
        {label}
      </div>
      <div style={{
        fontSize: 'var(--font-2xl)',
        fontWeight: 700,
        color: 'var(--amber)',
        fontVariantNumeric: 'tabular-nums',
        lineHeight: 1.2,
      }}>
        {valor?.toLocaleString('pt-BR') ?? '—'}
      </div>
      {(al !== undefined || ra !== undefined) && (
        <div style={{
          display: 'flex',
          gap: '12px',
          marginTop: '8px',
          fontSize: 'var(--font-xs)',
          color: 'var(--muted)',
        }}>
          {al !== undefined && <span>AL: {al.toLocaleString('pt-BR')}</span>}
          {ra !== undefined && <span>RA: {ra.toLocaleString('pt-BR')}</span>}
        </div>
      )}
    </div>
  );
}
